import { ANALYZE_FOR_ENTRY_COMPONENTS, Component, Input, OnChanges, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { ComponentService } from '../../../services/component.service';
import { TAB, TABPANEL } from '../../../../app/class/appinterface'
import { DxTabPanelComponent } from 'devextreme-angular';
import { NavigationEnd, Router } from '@angular/router';

@Component({
  selector: 'app-nica-tabs',
  templateUrl: './nica-tabs.component.html',
  styleUrls: ['./nica-tabs.component.css']
})


export class NicaTabsComponent implements OnInit {

  //@ViewChild('tabPanel',{static:true}) tabPanel:DxTabPanelComponent 

  @ViewChildren(DxTabPanelComponent) tabsPanel: QueryList<DxTabPanelComponent>

  @Input() name;
  @Input() relazioni: [];
  @Input() isActiveClose: boolean;
  @Input() tabHeight: number;

  tabs: TAB[] = [];
  itemClosed: any[];
  activeID: any[] = [];
  tabIndex: number;
  componentArray: any[]
  action: any;
  currentTab: TABPANEL[]
  constructor(private camponentService: ComponentService,private router: Router) { 

    
  }


  ngOnInit() {

    this.camponentService.currentTabs.subscribe(currentTabs => {
      
      this.currentTab = currentTabs

    })


    this.camponentService.tabs.subscribe(tabs => {
     
      this.renderTabsPanel(tabs);

      
    },
      err => {
        //console.log(err)
      }

    )
    this.camponentService.tabs.subscribe(tabs => {
      
      this.renderTabsPanel(tabs);

      
    },
      err => {
        //console.log(err)
      }

    )

  }

  renderAllTabsPanel(){
    alert("Render");
  }

  renderTabsPanel(tabsPanel) {

    this.tabs = []

   

    tabsPanel.filter(tab_name => { return tab_name.name == this.name });
    //console.log(tabsPanel)
    tabsPanel.forEach((tabPanel, index) => {
      
      if (tabPanel.name == this.name)

        this.tabs = tabPanel.dati;

      this.activeID[tabPanel.name] = 0;
      if (typeof tabPanel.dati != "undefined") {
        let length = 0;
        if (tabPanel.dati.length > 0) {
          length = tabPanel.dati.length
        }
        if (tabPanel.action == 'add') {
          let indexAdd = 0
          if (length > 0) {
            indexAdd = tabPanel.dati.length - 1



            if (this.currentTab[0].name == tabPanel.name) {

              if (this.tabsPanel) {



                this.tabsPanel.forEach(tPanel => {
                   setTimeout(() => {
                    tPanel.selectedIndex = indexAdd;   
                    tPanel.repaintChangesOnly = true;
                   }, 100); 
                  
                  
        

                })
              }
            }
          }
        }


        if (tabPanel.action == 'update') {
          if (this.currentTab[0].name == tabPanel.name) {

            if (this.tabsPanel) {


              //console.log('tabPanel',tabPanel)
              this.tabsPanel.forEach(tPanel => {
                 setTimeout(() => {
                  //console.log('tabPanel',tPanel)
                  tPanel.selectedIndex = tabPanel.dati.length-1;   
                  tPanel.repaintChangesOnly = false;
                 }, 200); 
                
                
      

              })
            }
          }

          
        }
        if (tabPanel.action == 'set') {


          if (this.currentTab[0].name == tabPanel.name) {
            if (this.tabsPanel)
              this.tabsPanel.forEach(tabPanel => {
                tabPanel.repaintChangesOnly = false

              })


          }




        }



        let tabHeight = this.defineHeight(Event)
        if (this.tabHeight >= 700) {
          this.tabHeight = this.tabHeight
        } else {
          this.tabHeight = tabHeight
        }

      }


    });


    ////console.log(this.activeID)
  }
  /** Funzioni Generali **/

  defineHeight(ev) {

    return (window.screen.height);
  }




  onOptionChanged(e, i) {
   
    const index = this.tabs.indexOf(e.addedItems[0]);
    this.camponentService.setCurrentTabPanel(i)
    


    if (this.currentTab[0].name == i) {
      this.tabsPanel.forEach(tabPanel => {
        tabPanel.repaintChangesOnly = false
        tabPanel.selectedIndex = index;
        

        this.activeID[i] = index
      })
      console.log(this.currentTab)
    }


    /*this.router.navigate(
      [item['cRouter']],
      {
        queryParams:item['params'],
        skipLocationChange: true, 
        replaceUrl: false     
      },
      
    )*/

  }




  showCloseButton(e:any) {
    if (typeof this.isActiveClose == "undefined") {
      this.isActiveClose = true
    }
    if (this.isActiveClose) {

      return this.tabs.length > 1;
    }


  }

  disableButton() {
    return;
  }

  closeTab(itemData, i,k) {
    //alert('fdfsdfg')
   
    const index = this.tabs.indexOf(itemData);

   
    if (this.currentTab[0].name == i)
      if (index < this.tabs.length) {
        

        this.tabsPanel.forEach(tabPanel => {
          let newIndex = index - 1
          tabPanel.selectedIndex = newIndex;
          tabPanel.repaintChangesOnly = true;


          this.activeID[i] = index;
          this.tabs.splice(index, 1)
        })





      } else if (index == this.tabs.length - 1) {
        //console.log('index' + index + '== ' + this.tabs.length + '-' + 1)
        this.tabs.splice(index, 1);

      } else if (index == 0) {

        if (confirm('Confermi di voler chiudere la  tua Dashboard, così facendo non potrai tornare più indietro')) {
          this.tabs.splice(index, 1)
        }
      }



  }

  selectionChanged(e) {
    //console.log(e)
  }

  FactiveID(e) {
    return 1
  }
}
